<template>
  <header class="header">
    <div class="display-name">
      {{ currentMerchant.display_name }}
    </div>
    <div class="header-images w-1/2 text-right">
      <template v-for="(stashboardHeader, index) in stashboardHeaders">
        <img v-if="stashboardHeader.attachment"
             :key="index"
             :src="cleanIconUrl(stashboardHeader.attachment.url)"
             class="stashboard-icon-preview" title="stashboard image"/>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  name: "campaign-creator-header",

  props: {
    currentMerchant: {
      type: Object,
      required: true
    },
    stashboardHeaders: {
      type: Array,
      required: true
    },
  },

  methods: {
    cleanIconUrl(url) {
      if (url.startsWith("http")) {
        return `${url}?h=47&w=47`;
      }
    },
  }
}
</script>

<style scoped>
.stashboard-icon-preview {
  width: 25px;
  height: 25px;
  margin: 0 3px;
}
</style>